import React, { useMemo } from 'react';
import * as R from 'ramda';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { Box, Divider } from '@mui/material';
import { css, useTheme } from '@emotion/react';

const listItemStyle = theme => ({
	padding: theme.spacing(1, 0)
});

const totalStyle = {
	fontWeight: 700
};

const titleStyle = theme => ({
	marginTop: theme.spacing(2)
});

const wrapStyle = css({
	display: 'flex',
	flexDirection: 'column'
});

const gridStyle = css({
	marginLeft: 'auto',
	textAlign: 'right'
});

function Review({ invoices = [] }) {
	const invoice = invoices && invoices[0];
	const theme = useTheme();
	const groups = useMemo(
		() => R.compose(R.toPairs, R.groupBy)(R.prop('id'), invoices),
		[invoices]
	);
	return invoice ? (
		<Box sx={wrapStyle}>
			<Typography variant="h5" sx={{ textAlign: 'center' }}>
				Invoice summary
			</Typography>
			<Grid container spacing={2}>
				<Grid sx={gridStyle} size={{ xs: 12, sm: 6 }}>
					<Typography
						variant="h6"
						gutterBottom
						sx={titleStyle}
						color="primary">
						Customer Information
					</Typography>
					<Typography sx={{ mb: '16px' }} component="div">
						{invoice.full_name}
						<br />
						{invoice.address_a}
						<br />
						{invoice.address_b}
						<br />
					</Typography>
					<Typography>{invoice.name_on_receipt}</Typography>
					<Typography
						variant="caption"
						sx={{ mb: '16px' }}
						component="div">
						{invoice.business_title}
					</Typography>
				</Grid>
			</Grid>
			<Divider sx={{ mb: '8px' }} />
			<Typography variant="h6" sx={{ textAlign: 'center' }}>
				Invoice Items
			</Typography>
			<List>
				{groups?.map(([invoiceID, invoices], index) => (
					<>
						<ListItem
							sx={{ display: 'flex', flexDirection: 'column' }}>
							<ListItemText
								sx={{ alignSelf: 'flex-start' }}
								primary={
									<Typography>
										Invoice ID:{' '}
										<Box
											component="span"
											sx={{
												color: theme.palette.secondary
													.main
											}}>
											{invoiceID}
										</Box>
									</Typography>
								}></ListItemText>
							<List disablePadding sx={{ alignSelf: 'stretch' }}>
								{invoices?.map(invoice => (
									<ListItem
										sx={listItemStyle}
										key={index}>
										<ListItemText
											primary={invoice.product_name}
											secondary={invoice.create_date}
										/>
										<Typography variant="body2">
											${invoice.amount}
										</Typography>
									</ListItem>
								))}
							</List>
						</ListItem>
						<Divider sx={{ mt: 1, mb: 1 }} />
					</>
				)) ?? null}
				<Divider />
				<ListItem sx={listItemStyle}>
					<ListItemText primary="Total" sx={totalStyle} />
					<Typography variant="subtitle1" sx={totalStyle}>
						${invoice.total.toFixed(2)}
					</Typography>
				</ListItem>
			</List>
		</Box>
	) : (
		<div>Invoice not found</div>
	);
}

export default Review;
